import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	checkboxContent: {
		color: '#000',
		fontSize: 14,
		marginLeft: '25px !important',
		width: 400,
	},
	container: {},
	header: {
		fontSize: 14,
		marginTop: 16,
	},
});
